import { atom } from "jotai";

import type { UserInfo } from "@mirage/mosaics/UserProfilePage/types";

export const confettiTrackerAtom = atom<{
  [user_id: string]: boolean;
}>({});
export const userInfoAtom = atom<UserInfo | null>(null);
